import { createParser, system } from "../core";
import { t } from "../utils";
var config = {
  boxShadow: t.shadows("boxShadow"),
  textShadow: t.shadows("textShadow")
};
Object.assign(config, {
  shadow: config.boxShadow
});
/**
 * Types for box and text shadow properties
 */

export var shadow = system(config);
export var shadowParser = createParser(config);
//# sourceMappingURL=shadow.js.map